module.exports = __webpack_public_path__ + "img/2012-08-18 13.58.16.16dece77.jpg";